export enum ECustomSorter {
    ByEntryDate,
    ByStartingNumber
}
    
